module.exports = __webpack_public_path__ + "static/media/kokkaany1.c858b542.avif";